import { render, staticRenderFns } from "./SiteSummary.vue?vue&type=template&id=08ce5627&"
import script from "./SiteSummary.vue?vue&type=script&lang=js&"
export * from "./SiteSummary.vue?vue&type=script&lang=js&"
import style0 from "./SiteSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports